import React from 'react';
import { ModalFooterWithRouter as ModalFooter } from 'components/Modal/ModalFooter';
import { MODAL_BUTTON_TYPES } from 'constants';
import ANALYTICS from 'constants/analytics';
import { i18n } from 'utils/i18n';

const EditVehicleModalContent = ({ linkTo, describedByID }) => (
  <>
    <div id={describedByID}>
      <p className='modal-themed__section'>{i18n('edit_vehicle_modal_copy_1')}</p>
      <p className='modal-themed__section'>{i18n('edit_vehicle_modal_copy_2')}</p>
    </div>
    <ModalFooter
      buttons={[
        {
          linkTo,
          type: MODAL_BUTTON_TYPES.LINK,
          label: i18n('edit_vehicle_modal_accept'),
          analyticsKey: ANALYTICS.EDIT_VEHICLE,
          analyticsValue: ANALYTICS.EDIT_VEHICLE,
        },
        {
          type: MODAL_BUTTON_TYPES.DECLINE,
          label: i18n('edit_vehicle_modal_decline'),
          analyticsKey: ANALYTICS.EDIT_VEHICLE,
          analyticsValue: ANALYTICS.DONT_EDIT_VEHICLE,
        },
      ]}
    />
  </>
);

export default EditVehicleModalContent;
